<template>
  <search-summary-bar-link-matches
    :slug="slug"
    data-test="search-summary-dates"
    class="search-summary-dates"
    exclude-type="visibleMarker"
  >
    <template v-if="isSameMonth">
      <search-summary-bar-details-calendar-same-month :date-range="dateRange" />
    </template>
    <template v-else>
      <i18n-t keypath="{fromDate} - {toDate}">
        <template #fromDate>
          <pu-utc-date :date="dateRange.arrive" options="dayMonth" />
        </template>
        <template #toDate>
          <pu-utc-date :date="dateRange.depart" options="dayMonth" />
        </template>
      </i18n-t>
    </template>
  </search-summary-bar-link-matches>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class SearchSummaryBarDetailsCalendar extends Vue {
  @Prop()
  dateRange: { arrive: string; depart: string }

  @Prop({ required: false })
  slug?: string

  get isSameMonth() {
    const arrive = new Date(this.dateRange.arrive)
    const depart = new Date(this.dateRange.depart)
    return arrive.getMonth() === depart.getMonth()
  }
}

export default toNative(SearchSummaryBarDetailsCalendar)
</script>
<style scoped>
.search-summary-dates {
  word-spacing: -0.125em;
}
</style>
